/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M50.32 11.114a.777.777 0 00-.374-.114.776.776 0 00-.376.114L35.196 21.316v-4.889a.654.654 0 00-.653-.652H20.691a.654.654 0 00-.653.652V32.09L4.7 43.025a.663.663 0 00-.18.88l5.972 9.436a.644.644 0 00.93.18l3.214-2.282v38.445h5.238V47.523l30.07-21.35 30.039 21.35v36.93h-9.072V61.799H54.106v22.654H19.875c-.832 1.809-1.974 3.569-3.296 5.231h66.015a2.624 2.624 0 002.627-2.624V51.238l3.23 2.298c.474.31.8.017.93-.179l6.087-9.436a.632.632 0 00-.18-.88L50.321 11.114z"
    ></path>
    <path fill="#B92A2E" d="M44.901 49.837H29.94v14.961h14.962V49.837z"></path>
  </Svg>
)

export default Icon
